import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SeoHead from '../seo/SeoHead';
import { PAGES, BUSINESS, SITE_URL } from '../seo/businessConfig';
import { pageBreadcrumbs } from '../seo/schema';

const importAll = (r) => r.keys().map(r);
const images = importAll(require.context('../images', false, /\.jpg$/));

function Galeria() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const page = PAGES.galeria;
  const imageGallerySchema = {
    '@context': 'https://schema.org',
    '@type': 'ImageGallery',
    name: `Galeria zdjęć — ${BUSINESS.brandName}`,
    description: page.description,
    url: `${SITE_URL}/galeria`,
    about: { '@id': `${SITE_URL}/#business` },
  };

  return (
    <div className="relative bg-primary-olive min-h-screen">
      <SeoHead
        title={page.title}
        description={page.description}
        keywords={page.keywords}
        path={page.path}
        jsonLd={[pageBreadcrumbs('galeria'), imageGallerySchema]}
      />
      <Navbar />

      <main className="pt-32 md:pt-48 pb-20 px-6 md:px-12 max-w-7xl mx-auto">
        <header className="mb-12 md:mb-16">
          <h1 className="text-5xl md:text-7xl font-bold text-primary tracking-wide">
            Galeria
            <span className="text-primary opacity-50">/</span>
          </h1>
          <p className="mt-4 text-primary text-lg md:text-xl max-w-2xl leading-relaxed">
            Zdjęcia obiektu Zacisze Czarna Owca w Brzeżance: basen, sauna, jacuzzi, kort i teren pensjonatu.
          </p>
        </header>

        <div className="columns-1 sm:columns-2 md:columns-3 gap-6 space-y-6">
          {images.map((image, index) => (
            <div key={index} className="break-inside-avoid overflow-hidden rounded-md shadow-md group">
              <img
                src={image}
                alt={`Zacisze Czarna Owca Brzeżanka Strzyżów — zdjęcie ${index + 1} obiektu agroturystycznego`}
                className="w-full h-auto object-cover cursor-pointer transform transition-transform duration-500 group-hover:scale-110"
                onClick={() => openModal(image)}
                loading="lazy"
                width="800"
                height="600"
              />
            </div>
          ))}
        </div>
      </main>

      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
          onClick={closeModal}
          role="dialog"
          aria-modal="true"
          aria-label="Powiększone zdjęcie galerii"
        >
          <div className="relative max-w-5xl w-full flex justify-center">
            <img
              src={selectedImage}
              alt="Powiększone zdjęcie galerii Zacisze Czarna Owca"
              className="max-h-[90vh] max-w-full object-contain rounded-md shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              className="absolute -top-10 right-0 md:top-2 md:-right-12 text-white hover:text-primary-olive text-4xl font-bold transition-colors"
              onClick={closeModal}
              aria-label="Zamknij galerię"
            >
              &times;
            </button>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default Galeria;
